import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setLogin } from "./../_redux/commentSlice";
import UserPicture from "./common/UserPicture";
import PopupOption from "./common/PopupOption";
import Editor from "./common/Editor";
import { useTranslation } from "react-i18next";

function WriteComment(props) {
    const { handleCalcHeightBoxComment } = props;
    // __REDUX
    const { currentState } = useSelector(state => ({
        currentState: state.comment
    }));
    const { commentSetting } = currentState;
    const dispatch = useDispatch();
    // __REFERENCE
    const commentBox = useRef(null);
    // console.log(commentSetting);
    // __STATE
    // kiểm tra xem người dùng có click vào box viết bình luận hay không
    const [isWrite, setIsWrite] = useState(false);
    // state show 3 options(login,register,binh luan k can dang nhap);
    const [showOptions, setShowOptions] = useState(false);
    const { t } = useTranslation();
    // __EFFECT
    // effect postmessage and set clientHeight
    useEffect(() => {
        setTimeout(() => {
            window.parent.postMessage(
                { clientHeight: document.body.offsetHeight + 10 },
                "*"
            );
        }, 10);
    }, [showOptions, isWrite]);

    useEffect(() => {
        const observer = new ResizeObserver(entries => {
            for (let entry of entries) {
                if (entry.contentRect) {
                    handleCalcHeightBoxComment(entry.contentRect.height);
                }
            }
        });

        if (commentBox.current) {
            observer.observe(commentBox.current);
        }

        return () => observer.disconnect();
    }, []);

    // __FUNCTION
    // mở options lựa chọn các chế độ (đăng nhập , đăng ký, or bình luận k cần đăng nhập)
    const onOpenAndCloseOverlayOptions = (isShowOption, isWrite) => {
        setShowOptions(isShowOption);
        setIsWrite(isWrite);
        setTimeout(() => {
            window.parent.postMessage(
                { clientHeight: document.body.offsetHeight + 10 },
                "*"
            );
        }, 10);
    };
    //Mở box comment khi không đăng nhập
    const onOpenCommentNotLogin = isWrite => {
        if (commentSetting.isNotLogin === false) {
            dispatch(setLogin(true));
        }
        setIsWrite(isWrite);
    };
    // console.log(commentSetting.userInfo);
    return (
        <div
            ref={commentBox}
            className='box__comment mb-[10px] flex gap-[10px] py-[8px]  '>
            {/* <UserPicture /> */}
            <div className='w-full rounded-sm '>
                {/* hiển thị box 3 options (login,register,and bình luận k cần đăng nhập) khi click vào button  */}
                {showOptions &&
                    commentSetting.isNotLogin === false &&
                    !commentSetting?.userInfo?.userId && (
                        <PopupOption
                            onOpenCommentNotLogin={onOpenCommentNotLogin}
                            onOpenAndCloseOverlayOptions={
                                onOpenAndCloseOverlayOptions
                            }
                        />
                    )}
                {/* nếu không viết thì trở về trạng thái ban đầu   */}
                {isWrite == false && (
                    <div
                        onClick={() => onOpenAndCloseOverlayOptions(true, true)}
                        className='block h-[70px] w-full border border-[#CDE3FF] bg-[#EEF5FF] rounded-[5px] cursor-text '>
                        <input
                            style={{
                                fontStyle:
                                    commentSetting?.version &&
                                    commentSetting?.version === "2.0.0" &&
                                    commentSetting.commentConfiguration
                                        .themeConfig.commentBlock.defaultStyle
                            }}
                            className=' bg-[#EEF5FF] h-[40px] w-full rounded-[5px] py-[10px] px-[10px] focus:outline-none '
                            type='text'
                            placeholder={t("message.input.yourComment")}
                        />
                    </div>
                )}
                {/* khi bình luận mà k cần login show nội dung sau */}
                {commentSetting.isNotLogin &&
                    isWrite &&
                    !commentSetting?.userInfo?.userId && (
                        <Editor
                            isLogin={false}
                            setIsWrite={setIsWrite}
                            onOpenCommentNotLogin={onOpenCommentNotLogin}
                        />
                    )}
                {/* end box */}

                {/* box user da login */}
                {commentSetting.isNotLogin == false &&
                    isWrite &&
                    commentSetting?.userInfo?.userId && (
                        <Editor
                            isLogin={true}
                            setIsWrite={setIsWrite}
                            onOpenCommentNotLogin={onOpenCommentNotLogin}
                        />
                    )}
            </div>
        </div>
    );
}

export default WriteComment;
